import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PaymentGatewayRecordsState } from './payment-gateway.reducer';

export const selectDataState = createFeatureSelector<PaymentGatewayRecordsState>('paymentGatewayRecords');

export const selectConnectUrl = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.connectUrl
);

export const selectConnectionLoading = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.connectionLoading
);

export const selectCollectMasterLoading = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.collectMasterLoading
);

export const selectHasConnect = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.hasConnect
);

export const selectHasCollectMaster = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.hasCollectMaster
);

export const selectDataLoading = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.loading
);

export const selectDataError = createSelector(
    selectDataState,
    (state: PaymentGatewayRecordsState) => state.error
);